// 预发环境（无独立测试环境，与线上同一套）
import type { GlobalEnv } from '../type'

export const preEnv: GlobalEnv = {
  baseUrl: import.meta.env.VITE_APP_API_URL, // 接口请求域名
  apiPrefix: '/rxk-saas/web/youka', // 接口请求前缀,一般对应于后端的服务
  uploadApi: import.meta.env.VITE_APP_API_URL + '/crm-report/file/upload', // 图片上传地址
  videoUplodApi: 'https://gw.youxinsign.com/rxk-saas/web/youka/video/transUpload', // 视频上传地址
  fileDownloadApi: 'https://gw.youxinsign.com/crm/file/download', // 文件下载地址
  websocketPath: import.meta.env.VITE_APP_WEBSOCKET_PATH, // websoket地址
  imgBaseUrl: import.meta.env.VITE_APP_FILE_URL, // 图片访问路径
  protocolPath: '', // 协议路径
  mapKey: '-', // 百度地图的key(公司)
  signKey:
    'x8eIC5sON7xKRbJeNttFibW5kGulL68Nz0ZXY4XurRBo4AQZB11Z0jIjFcLsIuitLQc29QeKyooorL32wZu5LZm8', // 签名的key
  aes: 'enc-', // 加密解密前缀
  secretKey: 'GQDTXGf7EZuCqwNG', // 解密用的key
  offset: '8GUUxywnlW0v9hk6',
  isNeedAes: false, // 是否需要加密
  sip_url: '@fs.jyunkj.cn', // sip:1008@fs.jyunkj.cn
  sip_socket_url: 'wss://fs.jyunkj.cn:7443',
  sip_session_timmers_expires: 150, // 会话计时器间隔
  sip_register_expires: 300, // 注册到期时间
  agreementPath: 'https://protocol.jyunkj.cn', // 协议
  iframeUrl: 'https://saas.youxinsign.com/#/', // iframe嵌套地址
  oldSystemType: '9U36B432B0L411EC818CB8599FE84K9Y', // 老系统连登type
  bpmH5Url: 'https://bpm.jyunkj.cn', // bpm公众号H5地址
  websiteUrl: 'saas.jyunkj.cn', // 官网地址
  websiteName: import.meta.env.VITE_APP_WEB_NAME
}
